import * as React from "react";
import { useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";

// import Divider from "@mui/material/Divider";
// import Avatar from 
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Badge from '@mui/material/Badge';

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FaceIcon from '@mui/icons-material/Face';
import MenuIcon from "@mui/icons-material/Menu";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import AddIcon from '@mui/icons-material/Add';
// import AnalyticsIcon from '@mui/icons-material/Analytics';
import SignpostIcon from '@mui/icons-material/Signpost';
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import SettingsIcon from "@mui/icons-material/Settings";
import Tooltip from "@mui/material/Tooltip";
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useSelector  } from "react-redux";
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import InventoryIcon from '@mui/icons-material/Inventory';
import MedicationIcon from '@mui/icons-material/Medication';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import DiscountIcon from '@mui/icons-material/LocalOffer';
import PaymentsIcon from '@mui/icons-material/Payments';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { deepOrange, } from '@mui/material/colors';

import AppLink from "./AppLink";
import BusinessIcon from '@mui/icons-material/Business';
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon";
import {reduceString} from "../helpers"
import { selectUser } from "../modules/auth/store/selectors";
import { selectDashboardState } from "../modules/admin/store/selectors";



const drawerWidth = 200;

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

type Roles = 'super_admin' | 'admin' | 'unverified_admin';

interface IDrawerMenuItem {
  id: number;
  title: string;
  url: string;
  Icon:  OverridableComponent<SvgIconTypeMap> & { muiName: string };
  stateCollected?: string;
  showCreate: boolean;
  createRoute?: string;
  minPermission: Roles;

}

let items: Array<Omit<IDrawerMenuItem, 'id'> > = [
  { title: "Dashboard", url: "/admin/dashboard", Icon: DashboardIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: 'Feed', url: '/admin/feeds', Icon: SignpostIcon, showCreate: true,  minPermission: 'super_admin'},
  { title: "Patients", url: "/admin/patients", Icon: FaceIcon, showCreate: true,  minPermission: 'super_admin' },
  { title: "Physicians", url: "/admin/physicians", Icon: LocalHospitalIcon, showCreate: true,  minPermission: 'super_admin'  },
  {title: 'Agent', url: '/admin/agents', Icon: SignpostIcon, showCreate: true,  minPermission: 'super_admin'},
  {title: "Contractors", url: '/admin/contractors', Icon: HealthAndSafetyIcon, showCreate: true,  minPermission: 'super_admin' },
  {title: "Appointments", url: '/admin/appointments', Icon: PendingActionsIcon, showCreate: false ,  minPermission: 'super_admin'},
  {title: "Requests", url: '/admin/requests', Icon: AssignmentIndIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: "Withdrawals", url: '/admin/withdrawal-requests', Icon: PaymentsIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: "Refunds", url: '/admin/refunds', Icon: AssignmentReturnIcon, showCreate: true,  minPermission: 'super_admin'},

  {title: "Activity", url: '/admin/activity', Icon: AccessTimeFilledIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: "Unverified", url: '/admin/unverified', Icon: NotificationImportantIcon, showCreate: false,  stateCollected:"unverifiedPhysicians",  minPermission: 'super_admin'},
  {title: "Deleted", url: '/admin/deleted-users', Icon: DeleteSweepIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: "Lab Tests", url: '/admin/invites', Icon: InventoryIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: "Admin & Orgs", url: '/admin/admin-orgs', Icon: BusinessIcon, showCreate: true, createRoute: 'create-admin',  minPermission: 'super_admin'},
  {title: "Prescriptions", url: '/admin/prescriptions', Icon: MedicationIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: "Transactions", url: '/admin/transactions', Icon: PointOfSaleIcon, showCreate: false,  minPermission: 'super_admin'},
  {title: 'Affiliates', url: '/admin/affiliates', Icon: SignpostIcon, showCreate: true,  minPermission: 'super_admin'},
  {title: 'Discounts', url: '/admin/discounts', Icon: DiscountIcon, showCreate: true,  minPermission: 'super_admin'},

  
/***********************************Outside Admins *****************************************************/  
  
  { title: "Dashboard", url: "/admin/home", Icon: DashboardIcon, showCreate: false,  minPermission: 'admin'},

  { title: "Members", url: "/admin/members", Icon: FaceIcon, showCreate: true,  minPermission: 'admin' },

  {title: "My Organization", url: '/admin/admin-my-orgs', Icon: BusinessIcon, showCreate: true, createRoute: 'create-admin',  minPermission: 'admin'},


  // {title: "Tags", url: '/tags', Icon: LocalOfferIcon, showCreate: false}


]


function getHeading(pathName: string, items: IDrawerMenuItem[]) {
 
    for (const item of items) {
        if(item.url === "/" ) {
         

          if(pathName === "/dashboard/")  return item.title;
          if(pathName === "/") return "Dashboard";
        }
       else if(pathName.includes(item.url)) {
            return item.title
        }
        
    }
    return "Settings"
}

function getPathId(pathName: string, items: IDrawerMenuItem[]) {
 
  for (const item of items) {
      if(item.url === "/" ) {
       

        if(pathName === "/dashboard/")  return item.id;
      }
     else if(pathName.includes(item.url)) {
          return item.id
      }
      
  }
  return 0
}
export default function Header(props: Props) {
  let location = useLocation();
  const [heading, setHeading] = React.useState("");
  const [pathId, setPathId]  = React.useState(0);
  let user = useSelector(selectUser);
  const drawerItems: IDrawerMenuItem[] = React.useMemo(() => {
    if(!user) return [];
    return items.filter(item => item.minPermission === user!.Role).map((item, index) => {
      return {
        ...item,
       id: index
      } as IDrawerMenuItem;
    })
  }, [user]);

  React.useEffect(() => {
    setHeading(getHeading(location.pathname, drawerItems))
    setPathId(getPathId(location.pathname, drawerItems))
 
 
  }, [location, drawerItems]);
  // const state = useSelector((state: AppState) => state.settings.darkMode);
  
  let  dashboard  = useSelector(selectDashboardState);
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

   const check = async ()=> {
    // let ans = await api.getModelList<Physician>("physician", "count", {isVerified: false, Status: { '!=': 6 }});
    // let ans2 = await api.getModelList<Contractor>("contractor", "count", {isVerified: false, Status: { '!=': 6 }});
    // dispatch({type: "load-unverified", unverifiedPhysicians: ans.total + ans2.total})
    //  
   }

      React.useEffect(() => {
          check();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])

      
  
 

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <AppLink to="/admin/settings" doNotUseButton>
      <Box padding="1em 0 1em 4px" display={"flex"}>
          <Avatar sx={{ bgcolor: deepOrange[500] }} src={user?.PhotoUrl} alt={user?.Name} />
       <Box marginLeft={'8px'}>
          <Typography variant="subtitle2" fontWeight={"bold"}>{reduceString(user?.Name || "Error", 16)}</Typography>
          <Typography variant="subtitle2" color="#6B779A" fontSize={10}>{user?.Role}</Typography>
          </Box>
      </Box>
      </AppLink>
 
      <List>
        {drawerItems.map((Item, index) => {
          const to = ("" + Item.url) 
            let selected =  location.pathname.includes(to)
            if(to === "/"  && selected) {
              selected = to === location.pathname;
            }  
          return (
            <AppLink to={to} doNotUseButton key={'ereder-drawer-item' + index}>
          <ListItem selected={selected} button sx={{
              borderRadius: 15,
              fontSize: '14px'
          }} >
            <ListItemIcon   style={{
              color:  selected ? "#336CFB": "inherit",
              fontSize: '14px'
            }}>
              <Item.Icon fontSize="small"/>
            </ListItemIcon>
            <ListItemText primary={Item.title} sx={{
              color:  selected ? "#336CFB": "inherit",
              "& .MuiTypography-root": {
                  fontSize: 14
              }

            }}  />
         {Item.stateCollected && (   <Badge color="primary" badgeContent={dashboard[Item.stateCollected]} />)}
          </ListItem>
          </AppLink>
        )
        }
        )}
     
      </List>
      {/* <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))} 
      </List>
      */}
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
    const drawerItem = drawerItems.length > 0 ?  drawerItems[pathId] : undefined;
    const shouldShowCreate = drawerItem?.showCreate;


  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        color="inherit"
        elevation={0}
        position="fixed"
        style={{ top: 0 }}
        sx={{
            width: { md: `calc(100% - ${drawerWidth}px)` },
            ml: { md: `${drawerWidth}px` },
          }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap fontWeight={700}>
             {heading}
          </Typography>
       
          <Box sx={{ flexGrow: 1 }} />
 
 {shouldShowCreate && (
   <AppLink doNotUseButton to={`${drawerItem.url}/${drawerItem.createRoute || 'create'}`} style={{
     marginRight: '1em'
   }}>
      <Tooltip title={`Add ${drawerItem.title}`}>
            <IconButton
      
              size="large"
              edge="end"
              color="inherit"
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
   </AppLink>
 )}
          
 <AppLink doNotUseButton to="/admin/settings">
          <Tooltip title="Settings">
            <IconButton
      
              size="large"
              edge="end"
              color="inherit"
            >
              <SettingsIcon />
            </IconButton>
          </Tooltip>
          </AppLink>
        </Toolbar>
       </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { sm: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
         
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          
          sx={{
            display: { sm: "none", xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,  
              borderRight: 'none',
              borderTop: 'none',
              "&:hover": {
                borderRight: '1px solid rgba(0, 0, 0, 0.12)'
              },
              height: '100vh'
            }, 
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          pt: 0,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      ></Box>
    </Box>
  );
 }

